import { InquiryDetailsComponent } from './../inquiry-details/inquiry-details.component';
import { element } from 'protractor';
import { PostService } from './../../Services/post.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeleteComponent } from '../modals/delete/delete.component';
import { MatDialog } from '@angular/material/dialog';

import { saveAs } from 'file-saver';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { contentLists } from '../contentForms';
import { GetService } from 'src/app/Services/get.service';
import { URLs } from 'src/app/URLs';
import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { environment } from 'src/environments/environment';
import { ngxCsv } from 'ngx-csv';
import { Subscription } from 'rxjs';
import { OrderNumberService } from 'src/app/Services/order-number.service';
import { ErrorsComponent } from '../modals/errors/errors.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit, OnDestroy {
  dataSource: any = new MatTableDataSource<any>();
  // dataSource:any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[];
  columnsTitles: string[];
  contentTypeData: any;
  type: string;
  from: any;
  to: any;
  urlsList: string;
  category_id: string;
  currentUrl;
  selectedFilterValue: string;
  selectedSortValue: string;
  filterData = [{ value: 'all', viewValue: 'All' },
  { value: 'axa', viewValue: 'Axa' },];
  id: number;
  checked: boolean = false;
  imgUrl = environment.imgUrl;
  deleteLink?: string;
  numberForOrder;
  routeSubscription = new Subscription();
  sorts = [
    { value: 'new', viewValue: 'New' },
    { value: 'old', viewValue: 'Old' },
  ];
  listSubscriptions = new Subscription();
  filterSubscription = new Subscription();
  SelectlistSubscriptions = new Subscription();
  sortSubscription = new Subscription();
  searchSubscription = new Subscription();
  deleteSubscription = new Subscription();
  checkBoxSubscription = new Subscription();
  backendErrors = new Array();
  constructor(
    private service: GetService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public spinner: NgxSpinnerService,
    private router: Router,
    private post: PostService, 
    private orderService: OrderNumberService
  ) { }

  ngOnInit(): void {
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.routeSubscription.unsubscribe();
        this.listSubscriptions.unsubscribe();
        this.filterSubscription.unsubscribe();
        this.SelectlistSubscriptions.unsubscribe();
        this.sortSubscription.unsubscribe();
        this.searchSubscription.unsubscribe();
        this.deleteSubscription.unsubscribe();
        this.checkBoxSubscription.unsubscribe();
        this.ngOnInit();
      }
    });
    this.spinner.show();
    this.type = this.route.snapshot.paramMap.get('type');
    this.contentTypeData = contentLists[this.type];
    this.deleteLink = contentLists[this.type]?.deleteLink;


    // if(this.type=='applicants'){
    //   this.getSelectData();
    // }

    this.listSubscriptions = this.service.get(this.listUrl()).subscribe((res) => {

      switch (this.type) {

        case 'media':
          this.dataSource = new MatTableDataSource(
            res.response.data.medias
          );
          break;
        case 'cali_units_gallery':

          this.dataSource = new MatTableDataSource(
            res.response.data.cali_units_gallery
          );
          break;
          case 'baymount_units_gallery':

          this.dataSource = new MatTableDataSource(
            res.response.data.baymount_units_gallery
          );
          break;
        case 'media_gallery':
          this.dataSource = new MatTableDataSource(
            res.response.data.media.media_gallery
          );
          break;
        case 'faq_category':
          this.dataSource = new MatTableDataSource(
            res.response.data.category_elements
          );
          break;
        case 'home_sister_company':
        case 'home_about':
        case 'home_partners':
        case 'about_values':
        case 'partners':
        case 'about_directors':
        case 'contact_requests':
        case 'about_sister_company':
        case 'contact_addresses':
        case 'contact_projects':
        case 'menu_pages':
        case 'cali_map':
        case 'cali_partners_details':
        case 'cali_statistics':
        case 'cali_masterplan':
        case 'cali_partners':
        case 'cali_inquiry_unit':
        case 'cali_inquiry_time':
          case 'baymount_map':
            case 'baymount_statistics':
            case 'baymount_masterplan':
            case 'baymount_partners':
            case 'baymount_inquiry_unit':
            case 'baymount_inquiry_time':
        case 'axa_benefits':
        case 'axa_additional_services':
        case 'customer_care_phone':
        case 'axa_inquiry_projects':
        case 'offers_inquiry_project':  
          this.dataSource = new MatTableDataSource(
            res.response.data.elements
          );
          console.log(res.response.data.elements);

          break;
        default:
          this.dataSource = new MatTableDataSource(res.response.data);
          console.log(res.response.data);
          break;
      }
      if(this.contentTypeData.hasAddButton || this.contentTypeData.hasCategoryAdd){
       
          this.numberForOrder = this.dataSource.data.length +1;
        this.orderService.order_number = this.numberForOrder;
      }



      this.displayedColumns = contentLists[this.type]?.columns;
      this.columnsTitles = contentLists[this.type]?.titles;

      this.dataSource.filterPredicate = (data: Element, filter: string) => {
        return data.id != filter;
      };

      setTimeout(() => {
        this.spinner.hide();
      }, 1000);
    });

  }
  dateRangeCreated($event) {
    this.from = $event[0].toJSON().split('T')[0];
    this.to = $event[1].toJSON().split('T')[0];
  }





  handelSearch() {
    if (this.from == '' && this.to == '') {
    } else {
      this.getSearch(this.from, this.to);
    }
  }

  filteringData(id: any) {
    this.spinner.show();

    let data = {
      filter: id,
    };
    if (id == 'all') {
      data = [{}];
    }
    this.filterSubscription = this.post.submit(this.contentTypeData.searchlink, data).subscribe(
      (data) => {

        this.dataSource = data.response.data;
      },
      (err) => {
      });
    setTimeout(() => {
      this.spinner.hide();
    }, 800)
  }
  sortData(sortValue) {
    this.spinner.show();
    let data: any = null;
    data = {
      sort: sortValue,
    };
    this.sortSubscription = this.post.submit(this.contentTypeData.searchlink, data).subscribe((data) => {
      this.dataSource = data.response.data;
    },
      (err) => {



      });
    setTimeout(() => {
      this.spinner.hide();
    }, 800);


  }
  getSearch(from, to) {
    this.spinner.show();
    let data: any = null;
    // if (this.urlsList == '') {
    data = {
      from: from,
      to: to,
      url: ['all'],
    };

    this.searchSubscription = this.post.submit(this.contentTypeData.searchlink, data).subscribe(
      (data) => {

        this.dataSource = data.response.data;
      },
      (err) => {



      });
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }
  checkIfElementsAdd(){
    this.service.get('dashboard/baymount_units/create/check').subscribe((res)=>{
      console.log(res.response.data);
      
      this.router.navigate(['/content-manager/add/'+ this.type])
      
    },(error)=>{
      this.backendErrors = error.error.errors;
      for(let errElement in this.backendErrors){
        for (let errItem = 0; errItem < this.backendErrors[errElement].length; errItem++) {
          const item = this.backendErrors[errElement][errItem];
        const dialogref = this.dialog.open(ErrorsComponent, {data: item})
        dialogref.afterClosed().subscribe((reply)=>{
         if(reply){
              this.dialog.closeAll();
         }
        })
      }
      }
    })
  }
  openDeleteDialog(item) {


    const dialogref = this.dialog.open(DeleteComponent, {
      data: 'Are You sure you want to delete this item?',
    });
    dialogref.afterClosed().subscribe((reply) => {
      if (reply== true) {
        this.deleteSubscription = this.service.Delete(this.deleteLink +'/' ,item.id).subscribe((del)=>{
         const index = this.dataSource.data.indexOf(item);
         this.dataSource.data.splice(index, 1);
           this.dataSource._updateChangeSubscription();
        },(error)=>{
         this.backendErrors = error.error.errors;
         for(let errElement in this.backendErrors){
           for (let errItem = 0; errItem < this.backendErrors[errElement].length; errItem++) {
             const item = this.backendErrors[errElement][errItem];
           const dialogref = this.dialog.open(ErrorsComponent, {data: item})
           dialogref.afterClosed().subscribe((reply)=>{
            if(reply){
                 this.dialog.closeAll();
            }
           })
         }
         }
        });
     }else{
       this.dialog.closeAll();



     }
    });
  }





  exportCsv(index = null) {

    if (index >= 0) {
      new ngxCsv([this.dataSource.data[index]], this.contentTypeData.title + " item", this.contentTypeData.exportOptions);
    }
    else {
      new ngxCsv(this.dataSource.data, this.contentTypeData.title, this.contentTypeData.exportOptions);

    }

  }
  listUrl(): string {
    let listUrl = contentLists[this.type]?.link;
    if (this.type == 'faq_category' || this.type == 'home_about' || this.type == 'home_sister_company' || this.type == 'home_partners' || this.type == 'partners'
      || this.type == 'about_values' || this.type == 'about_directors' || this.type == 'contact_requests' || this.type == 'contact_addresses' || this.type == 'contact_projects'
      || this.type == 'media' || this.type == 'media_gallery' || this.type == 'about_sister_company' || this.type == 'menu_pages' || this.type == 'cali_map' || this.type == 'cali_partners_details' || this.type == 'cali_inquiry_unit'
      || this.type == 'cali_inquiry_time' || this.type == 'cali_units_gallery' || this.type == 'cali_masterplan' || this.type == 'axa_additional_services'
      || this.type == 'cali_statistics' || this.type == 'cali_partners' || this.type == 'axa_benefits' || this.type == 'axa_inquiry_projects' || this.type=='customer_care_phone'
      || this.type=='offers_inquiry_project' || this.type == 'baymount_map' || this.type == 'baymount_statistics' || this.type == 'baymount_masterplan'
      || this.type == 'baymount_partners' || this.type == 'baymount_inquiry_unit' || this.type == 'baymount_inquiry_time'|| this.type == 'baymount_units_gallery') {
      this.category_id = this.route.snapshot.paramMap.get('category_id');
      listUrl += this.route.snapshot.paramMap.get('category_id');


    }
    return listUrl;
  }
  checkBoxvalue(event, id) {
    if (this.type == 'vacancies') {
      this.checked = event;
      let data: any = { id: id, is_active: Number(event) };
      this.checkBoxSubscription = this.service.Post('dashboard/vacancies/active/' + id, data).subscribe(
        (data) => {

        },
        (err) => {



        })
    } else if (this.type == 'home_media') {
      this.checked = event;
      let data: any = { id: id, is_featured: Number(event) };
      this.checkBoxSubscription = this.service.Post('dashboard/medias/featured/' + id, data).subscribe(
        (data) => {

        },
        (err) => {



        })
    }
  }
  // getSelectData(){
  //   this.SelectlistSubscriptions =  this.service.get(this.contentTypeData.selectData).subscribe((vacancies)=>{
  //       this.filterData = vacancies.response.data;
  //     });
  // }
  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.listSubscriptions.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.SelectlistSubscriptions.unsubscribe();
    this.sortSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.deleteSubscription.unsubscribe();
    this.checkBoxSubscription.unsubscribe();
  }
}
